/**
 * First-touch campaign parameters the website attaches to every lead form as hidden
 * fields. Blank means the visitor arrived organically or directly.
 */

export interface CampaignAttribution {
  utm_id: string;
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_content: string;
  utm_term: string;
  campaign_id: string;
  adgroup_id: string;
  ad_id: string;
  device: string;
  matchtype: string;
  gclid: string;
}

export const CAMPAIGN_ATTRIBUTION_LABELS: { key: keyof CampaignAttribution; label: string }[] = [
  { key: 'utm_source', label: 'UTM source' },
  { key: 'utm_medium', label: 'UTM medium' },
  { key: 'utm_campaign', label: 'UTM campaign' },
  { key: 'utm_term', label: 'UTM term' },
  { key: 'utm_content', label: 'UTM content' },
  { key: 'utm_id', label: 'UTM ID' },
  { key: 'campaign_id', label: 'Campaign ID' },
  { key: 'adgroup_id', label: 'Ad group ID' },
  { key: 'ad_id', label: 'Ad ID' },
  { key: 'device', label: 'Device' },
  { key: 'matchtype', label: 'Match type' },
  { key: 'gclid', label: 'Google click ID (gclid)' },
];

/** The parameters that were actually sent, in display order. */
export function filledCampaignAttribution(
  row: Partial<CampaignAttribution>
): { label: string; value: string }[] {
  return CAMPAIGN_ATTRIBUTION_LABELS.map(({ key, label }) => ({
    label,
    value: (row[key] ?? '').trim(),
  })).filter((entry) => entry.value !== '');
}
